import { Component, OnInit, Input } from '@angular/core';
import { ModalBaseComponent } from '../add-or-edit-org-modal/modal-base.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../data/data.service';
import { ActivatedRoute } from '@angular/router';
import { ParentSignUpRequest } from '../data/parent-signup-account';
import { AuthService } from '../auth.service';
import { RedirectService } from '../redirect.service';
import swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-add-parent-account-modal',
  templateUrl: './add-parent-account-modal.component.html',
  styleUrls: ['./add-parent-account-modal.component.css']
})
export class AddParentAccountModalComponent extends ModalBaseComponent<ParentSignUpRequest> implements OnInit {

  constructor(
    protected modalService: NgbModal,
    protected dataService: DataService,
    private authService: AuthService,
    private redirectService: RedirectService,
    private route: ActivatedRoute
  ) {
    super(modalService, dataService);
  }

  username: string;
  password: string;
  organizationId: number;
  @Input() loggingIn: boolean;
  passwordErrors: { length, upper, lower, other } = { length: false, upper: false, lower: false, other: false };

  ngOnInit() {
    this.route.url.subscribe(path => {
      this.organizationId = parseInt(path[2].path);
    });
  }

  initializeNewData() {
    this.data = {
      Name: '',
      Email: '',
      Password: '',
      OrganizationID: this.organizationId
    };
  }

  isInputValid(): boolean {
    return true;
  }

  openForNew() {
    this.modalHeader = "Add Parent Account";
    super.openForNew();
  }

  saveEdit() {

  }

  saveNew(): void {
    this.username = this.data.Email;
    this.password = this.data.Password;

    if (this.username && this.password) {
      this.dataService.createParentAccount(this.data).subscribe(response => {
        if (response) this.login();
        else this.validatePassword();
      }, error => console.error(error));
    } else {
      swal.fire('Oops!', 'Name or Email is required.', 'error');
    }
  }

  login() {
    this.isWaiting = true;
    this.dataService.createAccountSession(this.username, this.password).subscribe(session => {
      if (session != null) {
        this.authService.setSession(session);
        if (session.SessionType=== 'Parent') {
          this.redirectService.redirectToParentAccount(session.ID);
          this.modal.close();
          this.isWaiting = false;
        }
      }
    }, error => console.log(error));
  }

  validatePassword() {
    if (!this.data.Password) this.passwordErrors = { length: false, upper: false, lower: false, other: false };
    else this.passwordErrors = { 
      length: this.data.Password.length < 8,
      upper: !this.data.Password.match(/[A-Z]/),
      lower: !this.data.Password.match(/[a-z]/),
      other: !this.data.Password.match(/[^a-zA-Z]/)
    }
  }
}
